export const ajaxCart = (widget) => {
  $.ajax({
    url: '/cart',
    success: function (data) {
      const $total = $(data).find('.js-cart-global-total').html()
      $('.js-btn-cart strong').html($total)
      const $html = $(data).find('.js-cart-container').html()
      const $widgetCartContainer = $('.js-widget-cart .js-cart-container')

      if ($widgetCartContainer.length) {
        $widgetCartContainer.html($html)
        $('.js-widget-cart').addClass('is-expanded')

        if (widget !== true && widget !== false) {
          $widgetCartContainer.addClass('is-added')
        } else {
          $widgetCartContainer.removeClass('is-added')
        }
      } else {
        $('.js-cart-container').html($html)
      }
    }
  })
}
